export default __webpack_public_path__ + "static/media/Zero Knowledge Proof.0de76033.png";